import React, { Component } from "react";
import { connect } from "react-redux";
import ResetPassword from "../components/ResetPassword";
import actions from "../actions";
import { PropTypes } from "prop-types";
import Validators from "../../shared/utils/Validators";
import { I18n } from 'react-redux-i18n';

class ResetPasswordContainer extends Component {
    constructor(props) {
        super(props);

        const urlSplit = props.url.split('/');
        let code, user;
        if (urlSplit.length >= 5) {
            user = urlSplit[3];
            code = urlSplit[4];
        }

        this.state = {
            passwords: {
                password: {
                    value: "",
                    error: null,
                },
                repeatPassword: {
                    value: "",
                    error: null
                }
            },
            activationCode: code, //props.,
            userId: user
        };
    }

    validatePasswords = (key) => {
        let error;
        switch (key) {
            case "password":
                error = this.validatePassword();
                break;
            case "repeatPassword":
                error = this.validateRepeatPassword();
                break;
            default:
                break;
        }
        this.setState({
            ...this.state,
            passwords: {
                ...this.state.passwords,
                [key]: {
                    ...this.state.passwords[key],
                    error: error
                }
            }
        })
    };

    validatePassword = () => {
        const {
            passwords: {
                password: {
                    value : password
                }
            }
        } = this.state;

        return Validators.passwordLength(password) ?
            I18n.t('auth.errors.invalidPasswordLength', { charCount: "6" }) :
            !Validators.password(password) ?
                I18n.t('auth.errors.invalidPassword') :
                null;
    };

    validateRepeatPassword = () => {
        const {
            passwords: {
                password: {
                    value : password
                },
                repeatPassword: {
                    value : repeatPassword
                }
            }
        } = this.state;

        return Validators.passwordLength(repeatPassword) ?
            I18n.t('auth.errors.invalidPasswordLength', { charCount: "6" }) :
            repeatPassword !== password ?
                I18n.t('auth.errors.invalidPasswordMismatch') :
                null;

    };

    handlePasswordDataChanged = (value, key) => {
        const { passwords } = this.state;
        passwords[key].value = value;
        this.setState({ passwords });
        if (passwords[key].error) {
            this.validatePasswords(key);
        }
    }

    handleSubmit = () => {
        const {
            activationCode,
            userId,
            passwords: {
                password: {
                    value: password
                }
            }
        } = this.state;
        this.props.resetPassword({
            password,
            activationCode,
            userId
        });
    };

    render() {
        const { password, repeatPassword } = this.state.passwords;
        return (
            <ResetPassword
                {...this.props}
                password={password}
                repeatPassword={repeatPassword}
                handlePasswordDataChanged={this.handlePasswordDataChanged}
                handleFieldBlur={this.validatePasswords}
                handleSubmit={this.handleSubmit}
            />
        );
    }
}

ResetPasswordContainer.propTypes = {
    handleCollapseResetPasswordClicked: PropTypes.func.isRequired
};

const mapDispatchToProps = {
    handleCollapseResetPasswordClicked: actions.collapseResetPasswordForm,
    resetPassword: actions.resetPassword
};

export default connect(
    null,
    mapDispatchToProps
)(ResetPasswordContainer);
